import { render, staticRenderFns } from "./RepairAi.vue?vue&type=template&id=2b8b9d9e"
import script from "./RepairAi.vue?vue&type=script&lang=js"
export * from "./RepairAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports